import { createSlice, Draft } from '@reduxjs/toolkit'
import { CabinetFullInfo } from '../../context/cabinet'

export interface ICabinetStore {
  cabinetInfo: CabinetFullInfo | null;
  loading: boolean;
  updating: boolean;
}

const initialState: ICabinetStore = {
  cabinetInfo: null,
  loading: false,
  updating: false
}

export const cabinetSlice = createSlice({
  name: 'cabinet',
  initialState,
  reducers: {
    setCabinetInfo: (state: Draft<ICabinetStore>, { payload }: { payload: CabinetFullInfo | null }) => {
      state.cabinetInfo = payload
    },
    setCabinetLoading: (state: Draft<ICabinetStore>, { payload }: { payload: boolean }) => {
      state.loading = payload
    },
    setCabinetUpdating: (state: Draft<ICabinetStore>, { payload }: { payload: boolean }) => {
      state.updating = payload
    },
  }
})

export const { setCabinetInfo, setCabinetLoading, setCabinetUpdating } = cabinetSlice.actions

export default cabinetSlice.reducer
